import type React from 'react';

interface BagIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function BagIcon({ size = 24, ...props }: BagIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.33335 2.5C6.20075 2.5 6.07357 2.55268 5.9798 2.64645C5.88603 2.74021 5.83335 2.86739 5.83335 3C5.83335 3.48623 6.02651 3.95255 6.37033 4.29636C6.71414 4.64018 7.18046 4.83333 7.66669 4.83333H8.33335C8.81958 4.83333 9.2859 4.64018 9.62972 4.29636C9.97353 3.95255 10.1667 3.48623 10.1667 3C10.1667 2.86739 10.114 2.74021 10.0202 2.64645C9.92647 2.55268 9.7993 2.5 9.66669 2.5H6.33335ZM10.0921 5.2214C10.1774 5.15387 10.2591 5.08116 10.3368 5.00347C10.8682 4.47212 11.1667 3.75145 11.1667 3C11.1667 2.60218 11.0087 2.22064 10.7273 1.93934C10.446 1.65804 10.0645 1.5 9.66669 1.5H6.33335C5.93553 1.5 5.554 1.65804 5.27269 1.93934C4.99139 2.22064 4.83335 2.60218 4.83335 3C4.83335 3.75145 5.13187 4.47212 5.66322 5.00347C5.74091 5.08116 5.82264 5.15387 5.90793 5.2214C5.15255 5.51163 4.45849 5.95862 3.87523 6.54188C2.78127 7.63584 2.16669 9.11957 2.16669 10.6667V11.3333C2.16669 12.1732 2.50032 12.9786 3.09418 13.5725C3.68805 14.1664 4.4935 14.5 5.33335 14.5H10.6667C11.5065 14.5 12.312 14.1664 12.9059 13.5725C13.4997 12.9786 13.8334 12.1732 13.8334 11.3333V10.6667C13.8334 9.11957 13.2188 7.63584 12.1248 6.54188C11.5415 5.95862 10.8475 5.51163 10.0921 5.2214ZM8.00002 5.83333C6.71814 5.83333 5.48876 6.34256 4.58234 7.24898C3.67591 8.15541 3.16669 9.38479 3.16669 10.6667V11.3333C3.16669 11.908 3.39496 12.4591 3.80129 12.8654C4.20762 13.2717 4.75872 13.5 5.33335 13.5H10.6667C11.2413 13.5 11.7924 13.2717 12.1988 12.8654C12.6051 12.4591 12.8334 11.908 12.8334 11.3333V10.6667C12.8334 9.38479 12.3241 8.15541 11.4177 7.24898C10.5113 6.34256 9.2819 5.83333 8.00002 5.83333Z"
        fill="currentColor"
      />
    </svg>
  );
}
